/**
 * برچسبِ نمایشیِ یک تگ: «🎸 راک».
 *
 * قبلاً هر صفحه خودش `getLocale() === 'fa' ? labelFa : labelEn` می‌نوشت و
 * ایموجی بعضی جاها بود و بعضی جاها نه. یک‌جا ساختنش یعنی همه‌ی چیپ‌ها —
 * فرم‌ها، کشف، صفحه‌ی جزئیات، در هر دو اپ — یک شکل‌اند.
 *
 * تگی که کاربر خودش ساخته ایموجی ندارد (`''`) — `filter(Boolean)` نمی‌گذارد
 * فاصله‌ی یتیمی اولِ برچسب بماند.
 *
 * مثل `itemFields` باید موقعِ رندر صدا زده شود نه بالای ماژول، وگرنه با
 * عوض شدنِ زبان به‌روز نمی‌شود.
 */
import { getLocale, type Locale } from './i18n.ts';
import type { Tag } from '../domain/types.ts';

/**
 * فقط اسم، بی‌ایموجی — برای جایی که خودش ایموجی را جدا نشان می‌دهد یا
 * متنِ خام می‌خواهد (جستجوی کشف، تفاوتِ سیگنال).
 *
 * سه پله، دقیقاً مثل `t()` و مثل `nstr()`ِ سمتِ دیتابیس:
 *
 *   ۱. برچسبِ زبانِ فعال، از `tag_labels` (مایگریشن 0144).
 *   ۲. انگلیسی — تصمیمِ WHOSUP-212: ترجمه‌ی نبوده ⟵ انگلیسی، نه رشته‌ی
 *      خالی و نه `slug`. کاربرِ آلمانی که «Jazz» ببیند مشکلی ندارد؛ کسی که
 *      «music-jazz» یا هیچ ببیند، دارد.
 *   ۳. دو ستونِ قدیمی، برای تگی که `labels` ندارد — یعنی حالتِ دمو و
 *      فیکسچرها. (ردیفِ واقعیِ دیتابیس همیشه دستِ‌کم `en` دارد.)
 *
 * ⚠ `slug` هیچ‌وقت به کاربر نشان داده نمی‌شود، حتی به‌عنوان آخرین پله — مگر
 * تگی که هیچ برچسبی از هیچ راهی ندارد، که دیتابیس اجازه‌اش را نمی‌دهد.
 */
export const tagText = (tag: Tag, locale: Locale = getLocale()): string =>
  tag.labels?.[locale]
  || tag.labels?.en
  || (locale === 'fa' ? tag.labelFa : tag.labelEn)
  || tag.labelEn
  || tag.slug;

export const tagLabel = (tag: Tag): string =>
  [tag.emoji, tagText(tag)].filter(Boolean).join(' ');
